import React from 'react'

const Manual_requisiciones_enviar_una_requisicion = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
    <div className="mt-16">
     <h2 className="font-bold xl:text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
     Requisiciones - Enviar una Requisición
     </h2>
     <p className="text-lg text-gray-700 mb-6">
     Esta guía proporciona un proceso paso a paso para enviar requisiciones
eficientemente dentro de su sistema de gestión de inventario. Siguiendo estas
instrucciones, los usuarios pueden agilizar la transferencia de productos entre
sucursales, garantizando un seguimiento preciso y actualizaciones de estado. Su
diseño claro ayuda a prevenir errores durante el proceso, lo que la convierte en un
recurso esencial para mantener un control de inventario eficaz.
     </p>
     <iframe
          src="https://scribehow.com/embed/Requisiciones__Enviar_una_Requisicion___qChpsZNSc-01-s9v0aFNw?as=scrollable"
          className="scribe-iframe-general-4"
          width="100%"
          height="7140"
          allowFullScreen
          style={{
            aspectRatio: '1 / 1',
            border: 0,
            minHeight: '480px'
          }}
        ></iframe>
   </div>
   </div>
  )
}

export default Manual_requisiciones_enviar_una_requisicion